module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAZElEQVQ4T+2UQQoAIQwDm3/p63f/FUFwV7yIkhwEPVkKg6RTQfKJiBT/eQHkVm71SbID1isAdND1/lFQfaZjnor6G4gC1hge6JaHM4+PUmp9Y2YbZ8lUqZJXKctLLZleT+X/aQEeVMRytR/4+QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_more.png
// module id = 276
// module chunks = 48